// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c2587d36","793":"eb3e62e5"}[chunkId] + ".chunk.js";
};